module.exports = __webpack_public_path__ + "static/media/stars2.570a4f3f.png";